// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-header[data-v-7b23e6d8] {\n    background-color: var(--greyBg-color) !important;\n}\n.download-pdf[data-v-7b23e6d8] {\n    width: 35px !important;\n    min-width: 35px !important;\n    padding-left: 8px !important;\n}\n", ""]);
// Exports
module.exports = exports;
